export function canAbsorbPanelWheel(el, { deltaX = 0, deltaY = 0 } = {}) {
  if (!el) return false;

  if (el.classList?.contains("mood__chips")) {
    const max = el.scrollWidth - el.clientWidth;
    if (max <= 0) return false;

    // ChipRow redirects a plain vertical mouse wheel horizontally. Let that
    // event reach the row too; real horizontal trackpad gestures use deltaX.
    const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;
    if (delta < 0 && el.scrollLeft <= 0) return false;
    if (delta > 0 && el.scrollLeft >= max - 1) return false;
    return delta !== 0;
  }

  const max = el.scrollHeight - el.clientHeight;
  if (max <= 0) return false;
  if (deltaY < 0 && el.scrollTop <= 0) return false;
  if (deltaY > 0 && el.scrollTop >= max - 1) return false;
  return deltaY !== 0;
}
